import { getPageLanguage } from '@/infrastructure/Utils'
import { translate } from 'rhg-vue-common'

export default () => {
  const createErrorModal = (errorMessage, button, preventClose = true) => {
    const options = {
      backdrop: 'static',
      keyboard: false
    }
    const text = {
      title: errorMessage?.title || errorMessage?.message || errorMessage,
      subtitle: errorMessage?.subtitle || ''
    }
    global.ModalMessage.modal('#modal-error')
      .text(text)
      .options(preventClose ? options : null)
      .button(button)
      .show()
  }

  const errorFactoryModal = (error = {}) => {
    const button = {
      show: true,
      url: window.location.href,
      label: ''
    }
    const contactFormDeepLink = `/${getPageLanguage().toLowerCase()}${translate(
      'paClaimPointsFailedCTADeepLink'
    )}`

    switch (error.type) {
      case global.ProblemTypes.customerIdNotMatching:
        button.url = contactFormDeepLink
        button.label = translate('paClaimPointsFailedCTA')
        error.title = translate('errLoCustomerIdNotMatchingTitle')
        error.subtitle = translate('errLoCustomerIdNotMatchingDescription')
        createErrorModal(error, button, false)
        break

      case global.ProblemTypes.reservationDoesNotExit:
        button.url = contactFormDeepLink
        button.label = translate('paClaimPointsFailedCTA')
        error.title = translate('errLoReservationDoesNotExitTitle')
        error.subtitle = translate('errLoReservationDoesNotExitDescription')
        createErrorModal(error, button, false)
        break

      case global.ProblemTypes.reservationNonEligible:
        button.url = contactFormDeepLink
        button.label = translate('paClaimPointsFailedCTA')
        error.title = translate('errLoReservationNonEligibleTitle')
        error.subtitle = translate('errLoReservationNonEligibleDescription')
        createErrorModal(error, button, false)
        break

      case global.ProblemTypes.reprocessingPeriodSurpassed:
        button.url = contactFormDeepLink
        button.label = translate('paClaimPointsFailedCTA')
        error.title = translate('errLoreProcessingPeriodSurpassedTitle')
        error.subtitle = translate('errLoreProcessingPeriodSurpassedDescription')
        createErrorModal(error, button, false)
        break

      case global.ProblemTypes.pointsAlreadyAwarded:
        button.url = contactFormDeepLink
        button.label = translate('paClaimPointsFailedCTA')
        error.title = translate('errLoPointsAlreadyAwardedTitle')
        error.subtitle = translate('errLoPointsAlreadyAwardedDescription')
        createErrorModal(error, button, false)
        break

      case global.ProblemTypes.reservationNameDoesNotMatchWithLoyatlyName:
        button.url = contactFormDeepLink
        button.label = translate('paClaimPointsFailedCTA')
        error.title = translate('errLoreservationNameDoesNotMatchWithLoyatlyNameTitle')
        error.subtitle = translate('errLoreservationNameDoesNotMatchWithLoyatlyNameDescription')
        createErrorModal(error, button, false)
        break

      case global.ProblemTypes.enrollmentDateAfterCheckOutDate:
        button.show = false
        error.title = translate('errLoEnrollmentDateAfterCheckOutDateTitle')
        error.subtitle = translate('errLoEnrollmentDateAfterCheckOutDateDescription')
        createErrorModal(error, button, false)
        break

      case global.ProblemTypes.loyaltyInternalServerError:
        button.url = contactFormDeepLink
        button.label = translate('paClaimPointsFailedCTA')
        error.title = translate('errLoLoyaltyInternalServerErrorTitle')
        error.subtitle = translate('errLoLoyaltyInternalServerErrorDescription')
        createErrorModal(error, button, false)
        break

      case global.ProblemTypes.onlinePaymentGatewayFraud:
        error.title = translate('errBoPaymentCancelled')
        button.show = false
        createErrorModal(error, button, false)
        break

      case global.ProblemTypes.onlinePaymentGatewayTimeout:
        error.title = translate('errBoSessionExpired')
        button.show = false
        createErrorModal(error, button, false)
        break

      default:
        global.ApiHandlers.handleErrorsMessage(error)
    }
  }

  return {
    errorFactoryModal,
    createErrorModal
  }
}
